export default __webpack_public_path__ + "static/quickGuideImage-dcd482255ebf0b0312cb44e3ea093917.png";